// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__209bW","content":"style_content__PRa2q","img":"style_img__2E_Ek","header":"style_header__1Q0Wr","join":"style_join__Ijjfl"};